export const LOGIN = '/login';
export const ADMIN = '/admin';
export const ORDERS = '/orders';
export const MENU = '/menu';
export const PRACTICE_ALLOCATION = '/practices-allocation';
export const SYSTEM_CONFIGURATION = '/system-configuration';
